App.controller('LifeWithPaymentsIncidentCtrl', ['$scope', '$stateParams', function ($scope, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'life_incident';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Zgłoś zdarzenie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.life.start';
    $scope.$emit('link', $scope.link);
}]);